import moment from 'moment-jalaali'

const toFaDigits = (value: string): string => value.replace(/\d/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'[Number(digit)])

export const stringToFaDateTime = (dateString: string): string => {
  if (!dateString) return ''

  try {
    const date = moment(dateString)

    if (!date.isValid()) return dateString

    return toFaDigits(date.locale('fa').format('jYYYY/jMM/jDD, HH:mm:ss'))
  } catch {
    return dateString
  }
}
